import {AdminVI} from "./admin/vi";
import {UserVI} from "./user/vi";

export const SystemVI = {
    ...AdminVI,
    ...UserVI
}